
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/koodo/[[...slug]]",
      function () {
        return require("private-next-pages/koodo/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/koodo/[[...slug]]"])
      });
    }
  